import styled from 'styled-components';

interface avatarProps {
	small?: boolean;
	rounded?: boolean;
}

const Avatar = styled.div<avatarProps>`
	position: re
	transition: 
    transition: all ease 0.4s;
    ${({ small }) => small && `width: 36px; height: 36px;`}
    img{
        width: 100%;
		height: 100%;
		position: relative;
    }
`;
export default Avatar;
